"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var AccordionContext_1 = require("./AccordionContext");
/**
 * Accordion
 * @param props
 * @description
 * wrapper componet that keep track of 'expandedContentId'
 * it provide context for child components to update expandedContentId
 * Close follow this aria example
 * https://www.w3.org/TR/wai-aria-practices-1.1/examples/accordion/accordion.html
 */
var Accordion = function (props) {
    var children = props.children, className = props.className, collapseAll = props.collapseAll, expandedContentId = props.expandedContentId, isAccordion = props.isAccordion;
    var _a = React.useState(expandedContentId || ''), currentExpandedContentId = _a[0], setCurrentExpandedContentId = _a[1];
    React.useEffect(function () {
        if (isAccordion) {
            setCurrentExpandedContentId(expandedContentId || '');
        }
    }, [expandedContentId, isAccordion]);
    var contextValue = {
        collapseAll: collapseAll,
        expandedContentId: currentExpandedContentId,
        isAccordion: isAccordion,
        setExpandedContentId: setCurrentExpandedContentId,
    };
    var classnames = ("accordion " + className).trim();
    return (React.createElement("div", { className: classnames },
        React.createElement(AccordionContext_1.AccordionContext.Provider, { value: contextValue }, children)));
};
exports.Accordion = Accordion;
/* tslint:disable:no-string-literal */
exports.Accordion['propTypes'] = {
    className: PropTypes.string,
    collapseAll: PropTypes.bool,
    expandedContentId: PropTypes.string,
    isAccordion: PropTypes.bool,
};
exports.Accordion['defaultProps'] = {
    className: '',
    collapseAll: false,
    expandedContentId: '',
    isAccordion: true,
};
/* tslint:enable:no-string-literal */
